import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Paginator } from "primereact/paginator";
import PaintCoatingSystem from "./PaintCoating";
import EquipmentMachinerySystem from "./EquipmentMachinery";
import StructureHullSystem from "./StructureHull";
import StoresSystem from "./Stores";
import {
  getEquipmentMachinery,
  getPaintCoating,
  getStores,
  getStructureAndHull,
  postIhmPartInventory,
} from "../Actions/MMPLDashboardAPI";
import { toast, ToastContainer } from "react-toastify";
import swal from "sweetalert";
import axios from "axios";
import API from "../helpers/api";
import {
  UploadDocument,
  UploadRevisionDocument,
  UploadInventoryDocument,
  UploadInventory,
} from "../Actions/CommonAPI";
import { confirmAlert } from "react-confirm-alert";
import plusIcon from "../Asset/plus.svg";

class ViewIHMPart1Revision extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inventoryfile: "",
      inventoryFilename: "",
      option: "",
      PaintCoating: false,
      EquipmentMachinery: false,
      StructureHull: false,
      Stores: false,
      paintAndCoating: [],
      equipmentAndMachinery: [],
      structureAndHull: [],
      store: [],
      updateDetails: {},
      first: 0,
      Equipmentfirst: 0,
      Structurefirst: 0,
      Storefirst: 0,
      activePagePaintCoating: 0,
      activePageEquipment: 0,
      activePageStructure: 0,
      activePageStore: 0,
      data: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      ],
      rows: 5,
      submitIHMPart1: {
        shipId: "",
        paintAndCoating: [],
        equipmentAndMachinery: [],
        structureAndHull: [],
        store: [],
        createdBy: "",
        attachmentName: "",
        attachmentGuid: "",
        inventoryName: "",
        inventoryGuid: "",
      },
      file: "",
    };
    this.handlePaintCoatingPageChange =
      this.handlePaintCoatingPageChange.bind(this);
    this.handleEquipmentPageChange = this.handleEquipmentPageChange.bind(this);
    this.handleStructurePageChange = this.handleStructurePageChange.bind(this);
    this.handleStoresPageChange = this.handleStoresPageChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { shipid, poid } = params;
    dispatch({
      type: "SubBannerTitle",
      data: "INVENTORY OF HAZARDOUS MATERIALS",
    });
    if (shipid !== "" && poid !== "") {
      this.state.submitIHMPart1.shipId = parseInt(shipid);
      dispatch(getPaintCoating(shipid, poid));
      dispatch(getEquipmentMachinery(shipid, poid));
      dispatch(getStructureAndHull(shipid, poid));
      dispatch(getStores(shipid, poid));
    }
  }

  static getDerivedStateFromProps(props, prevState) {
    const { attachmentDetail, inventoryDetail } = props;
    if (attachmentDetail) {
      prevState.submitIHMPart1.attachmentName = attachmentDetail.FileName;
      prevState.submitIHMPart1.attachmentGuid = attachmentDetail.Guid;
      prevState.file = "";
    }
    if (inventoryDetail) {
      prevState.submitIHMPart1.inventoryName = inventoryDetail.FileName;
      prevState.submitIHMPart1.inventoryGuid = inventoryDetail.Guid;
    }
    if (prevState.inventoryfile !== "") {
      props.dispatch(UploadInventoryDocument(prevState.inventoryfile));
      prevState.inventoryfile = "";
    }
    return {
      paintAndCoating: props.paintCoating,
      equipmentAndMachinery: props.equipmentMachinery,
      structureAndHull: props.structureAndHull,
      store: props.store,
    };
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "fileName") {
      this.state.submitIHMPart1.attachmentName = e.target.files[0].name;
      this.state.file = e.target.files[0];
      this.setState({ submitIHMPart1: this.state.submitIHMPart1 });
      this.props.dispatch(UploadDocument(e.target.files[0]));
    } else if (nodeName === "inventoryName") {
      this.state.inventoryFilename = e.target.files[0].name;
      this.state.inventoryfile = e.target.files[0];
      this.setState({});
      // this.props.dispatch(UploadInventoryDocument(e.target.files[0]));
    }
  }

  UploadDocument() {
    let clearData = { FileName: "", Guid: "" };
    const { dispatch, match } = this.props;
    const { params } = match;
    const { shipid } = params;
    let update = {
      shipId: shipid,
      attachmentName: this.state.submitIHMPart1.attachmentName,
      attachmentGuid: this.state.submitIHMPart1.attachmentGuid,
    };
    if (update.attachmentName == "" && update.attachmentGuid == "") {
      swal("Error!", "Upload Revision Document is empty", "warning");
    } else {
      dispatch(UploadRevisionDocument(update, clearData));
    }
  }

  ClearInput() {
    this.state.submitIHMPart1.attachmentName = "";
    this.state.submitIHMPart1.attachmentGuid = "";
    let clearData = { FileName: "", Guid: "" };
    this.props.dispatch({
      type: "AttachmentUploadSuccess",
      data: clearData,
    });
  }

  ClearInputs = () => {
    this.setState({
      inventoryFilename: "",
      inventoryfile: "",
    });
  };

  deletePaintCoating(paintItem) {
    const { paintAndCoating } = this.state;
    paintItem.isDeleted = true;
    this.setState({ paintAndCoating });
  }

  deletePaint = (paintItem) => {
    const { paintAndCoating } = this.state;
    const { dispatch, match } = this.props;
    const { params } = match;
    const { shipid, poid } = params;
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            paintItem.isDeletePermanently = true;
            this.setState({ paintAndCoating });
            this.state.submitIHMPart1.paintAndCoating =
              this.state.paintAndCoating;
            this.state.submitIHMPart1.equipmentAndMachinery =
              this.state.equipmentAndMachinery;
            this.state.submitIHMPart1.structureAndHull =
              this.state.structureAndHull;
            this.state.submitIHMPart1.store = this.state.store;
            let url = `${API.PostInventory}`;
            axios
              .post(url, this.state.submitIHMPart1)
              .then((response) => {
                dispatch(getPaintCoating(shipid));
                // dispatch(getEquipmentMachinery(shipid));
                // dispatch(getStructureAndHull(shipid));
                // dispatch(getStores(shipid));
                dispatch({
                  type: "DeleteInventorySuccess",
                  data: response.data,
                });
                toast.success(" Deleted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "DeleteInventoryFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  deleteEquipmentAndMachinery = (Equipment) => {
    const { equipmentAndMachinery } = this.state;
    const { dispatch, match } = this.props;
    const { params } = match;
    const { shipid, poid } = params;
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            Equipment.isDeletePermanently = true;
            this.setState({ equipmentAndMachinery });
            this.state.submitIHMPart1.paintAndCoating =
              this.state.paintAndCoating;
            this.state.submitIHMPart1.equipmentAndMachinery =
              this.state.equipmentAndMachinery;
            this.state.submitIHMPart1.structureAndHull =
              this.state.structureAndHull;
            this.state.submitIHMPart1.store = this.state.store;
            let url = `${API.PostInventory}`;
            axios
              .post(url, this.state.submitIHMPart1)
              .then((response) => {
                // dispatch(getPaintCoating(shipid));
                dispatch(getEquipmentMachinery(shipid));
                // dispatch(getStructureAndHull(shipid));
                // dispatch(getStores(shipid));
                dispatch({
                  type: "DeleteInventorySuccess",
                  data: response.data,
                });
                toast.success(" Deleted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "DeleteInventoryFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  deleteStructureAndHull = (Structure) => {
    const { structureAndHull } = this.state;
    const { dispatch, match } = this.props;
    const { params } = match;
    const { shipid, poid } = params;
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            Structure.isDeletePermanently = true;
            this.setState({ structureAndHull });
            this.state.submitIHMPart1.paintAndCoating =
              this.state.paintAndCoating;
            this.state.submitIHMPart1.equipmentAndMachinery =
              this.state.equipmentAndMachinery;
            this.state.submitIHMPart1.structureAndHull =
              this.state.structureAndHull;
            this.state.submitIHMPart1.store = this.state.store;
            let url = `${API.PostInventory}`;
            axios
              .post(url, this.state.submitIHMPart1)
              .then((response) => {
                // dispatch(getPaintCoating(shipid));
                // dispatch(getEquipmentMachinery(shipid));
                dispatch(getStructureAndHull(shipid));
                // dispatch(getStores(shipid));
                dispatch({
                  type: "DeleteInventorySuccess",
                  data: response.data,
                });
                toast.success(" Deleted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "DeleteInventoryFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  deleteStore = (Store) => {
    const { StoreItem } = this.state;
    const { dispatch, match } = this.props;
    const { params } = match;
    const { shipid, poid } = params;
    confirmAlert({
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            Store.isDeletePermanently = true;
            this.setState({ StoreItem });
            this.state.submitIHMPart1.paintAndCoating =
              this.state.paintAndCoating;
            this.state.submitIHMPart1.equipmentAndMachinery =
              this.state.equipmentAndMachinery;
            this.state.submitIHMPart1.structureAndHull =
              this.state.structureAndHull;
            this.state.submitIHMPart1.store = this.state.store;
            let url = `${API.PostInventory}`;
            axios
              .post(url, this.state.submitIHMPart1)
              .then((response) => {
                // dispatch(getPaintCoating(shipid));
                // dispatch(getEquipmentMachinery(shipid));
                // dispatch(getStructureAndHull(shipid));
                dispatch(getStores(shipid));
                dispatch({
                  type: "DeleteInventorySuccess",
                  data: response.data,
                });
                toast.success(" Deleted successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "DeleteInventoryFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  deleteEquipmentMachinery(EquipmentItem) {
    const { equipmentAndMachinery } = this.state;
    EquipmentItem.isDeleted = true;
    this.setState({ equipmentAndMachinery });
  }

  deleteStructureHull(StructureItem) {
    const { structureAndHull } = this.state;
    StructureItem.isDeleted = true;
    this.setState({ structureAndHull });
  }

  deleteStores(StoreItem) {
    const { store } = this.state;
    StoreItem.isDeleted = true;
    this.setState({ store });
  }

  submitIHMPart1 = () => {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { shipid, poid } = params;
    this.state.submitIHMPart1.paintAndCoating = this.state.paintAndCoating;
    this.state.submitIHMPart1.equipmentAndMachinery =
      this.state.equipmentAndMachinery;
    this.state.submitIHMPart1.structureAndHull = this.state.structureAndHull;
    this.state.submitIHMPart1.store = this.state.store;
    // dispatch(postIhmPartInventory(this.state.submitIHMPart1));
    let url = `${API.PostInventory}`;
    axios
      .post(url, this.state.submitIHMPart1)
      .then((response) => {
        if (response.data) {
          let inventory = {
            shipId: shipid,
            attachmentName: this.state.submitIHMPart1.inventoryName,
            attachmentGuid: this.state.submitIHMPart1.inventoryGuid,
          };
          if (
            this.state.submitIHMPart1.inventoryName &&
            this.state.submitIHMPart1.inventoryGuid
          ) {
            dispatch(UploadInventory(inventory));
          }
        }
        dispatch({
          type: "PostHazardessMaterialsSuccess",
          data: response.data,
        });
        toast.success(" Part1 updated successfully.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.props.history.goBack();
        this.props.dispatch({ type: "ShowSidePan", data: false });
      })
      .catch((error) => {
        dispatch({
          type: "PostHazardessMaterialsFailure",
          error: "ERROR",
        });
      });
  };

  cancelIHMPart1() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.goBack();
  }

  CheckUpdates = () => {
    const { history, match } = this.props;
    const { params } = match;
    const { poid } = params;
    history.push(`/Home/CheckUpdate/${poid}`);
    window.scrollTo(0, 0);
  };

  hideSidePanels = () => {
    this.props.history.goBack();
  };

  render() {
    const { ShowSidePan } = this.props;
    const { PaintCoating, EquipmentMachinery, StructureHull, Stores } =
      this.state;
    return (
      <div className="row px-4">
        <div className={ShowSidePan ? "col-lg-12 new" : "col-lg-12"}>
          <button
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3 mx-0"
            onClick={() => this.hideSidePanels()}
          >
            &larr; Back
          </button>
        </div>
        <div className={ShowSidePan ? "col-lg-6 new" : "col-lg-12"}>
          <div className="full-height py-3">
            <div className="row">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className=" card MM-card-header mb-0"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body flex"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1E3A8A",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Hazardous Materials{" "}
                      </h5>
                    </div>
                  </div>
                  <div className="row search-filter-box">
                    <div className="col-lg-9">
                      <div className="row"></div>
                    </div>
                    <div className="col-lg-3 m-auto">
                      <div style={{ textAlign: "end", paddingTop: "8px" }}>
                        {/* <label className="form-label mt-1" >Check Updates </label> */}
                        <span>
                          <strong>Check Updates </strong>
                        </span>
                        <i
                          className="fa fa-eye click fa-lg"
                          aria-hidden="true"
                          onClick={() => this.CheckUpdates()}
                          style={{ color: " #1E3A8A", fontSize: "30px" }}
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div className="search-filter-box mt-1">
                    <div
                      className=" card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          Paint & Coating Systems
                        </h5>
                        {/* <div
                          className="m-1"
                          onClick={() =>
                            this.ShowSidePanel("Add", "paint and coating", "")
                          }
                        >
                          <AddIcon />
                        </div> */}
                      </div>
                    </div>
                    <div
                      className="search-filter-box history-box"
                      style={{ maxHeight: "400px" }}
                    >
                      {this.renderPaintCoating()}
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div
                      className=" card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          Equipment & Machinery
                        </h5>
                        {/* <div
                          className="m-1"
                          onClick={() =>
                            this.ShowSidePanel(
                              "Add",
                              "equipment and machinery",
                              ""
                            )
                          }
                        >
                          <AddIcon />
                        </div> */}
                      </div>
                    </div>
                    <div
                      className="search-filter-box history-box"
                      style={{ maxHeight: "400px" }}
                    >
                      {this.renderEquipmentMachinery()}
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div
                      className=" card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          Structure & Hull
                        </h5>
                        {/* <div
                          className="m-1"
                          onClick={() =>
                            this.ShowSidePanel("Add", "structure and hull", "")
                          }
                        >
                          <AddIcon />
                        </div> */}
                      </div>
                    </div>
                    <div
                      className="search-filter-box history-box"
                      style={{ maxHeight: "400px" }}
                    >
                      {this.renderStructureHull()}
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div
                      className=" card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          Stores
                        </h5>
                        {/* <div
                          className="m-1"
                          onClick={() =>
                            this.ShowSidePanel("Add", "stores", "")
                          }
                        >
                          <AddIcon />
                        </div> */}
                      </div>
                    </div>
                    <div
                      className="search-filter-box history-box"
                      style={{ maxHeight: "400px" }}
                    >
                      {this.renderStores()}
                    </div>
                  </div>
                  {/* <div className="search-filter-box">
                    <div className="row mb-2">
                      <div className="col-lg-12" style={{ textAlign: "right" }}>
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.submitIHMPart1()}
                        >
                          {" "}
                          Submit{" "}
                        </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.cancelIHMPart1()}
                        >
                          {" "}
                          Cancel{" "}
                        </button>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {ShowSidePan ? (
          <div className="col-lg-6">
            {PaintCoating ? (
              <PaintCoatingSystem
                option={this.state.option}
                updateDetails={this.state.updateDetails}
              />
            ) : null}
            {EquipmentMachinery ? (
              <EquipmentMachinerySystem
                option={this.state.option}
                updateDetails={this.state.updateDetails}
              />
            ) : null}
            {StructureHull ? (
              <StructureHullSystem
                option={this.state.option}
                updateDetails={this.state.updateDetails}
              />
            ) : null}
            {Stores ? (
              <StoresSystem
                option={this.state.option}
                updateDetails={this.state.updateDetails}
              />
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }

  ShowSidePanel = (item, type, details) => {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    if (item === "Add") {
      this.setState({ option: item });
      this.setState({ updateDetails: {} });
    } else if (item === "Edit") {
      this.setState({ option: item });
      this.setState({ updateDetails: details });
    }

    if (type === "paint and coating") {
      this.setState({
        PaintCoating: true,
        EquipmentMachinery: false,
        StructureHull: false,
        Stores: false,
      });
    } else if (type === "equipment and machinery") {
      this.setState({
        PaintCoating: false,
        EquipmentMachinery: true,
        StructureHull: false,
        Stores: false,
      });
    } else if (type === "structure and hull") {
      this.setState({
        PaintCoating: false,
        EquipmentMachinery: false,
        StructureHull: true,
        Stores: false,
      });
    } else if (type === "stores") {
      this.setState({
        PaintCoating: false,
        EquipmentMachinery: false,
        StructureHull: false,
        Stores: true,
      });
    }

    window.scrollTo(0, 0);
  };

  hideSidePanel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
  };

  EditIHMPart1 = () => {
    return (
      <div className="row" style={{ paddingBottom: "338px" }}>
        <div className="full-height pt-3">
          <div className="grey-bg  course-list-page">
            <div className="panel-box  search-filter-box mb-4">
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.hideSidePanel()}
              >
                &larr; Return
              </button>
              <div className="resource-list-auth-date">
                <div
                  className="card mt-2 MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="card-body">
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Paint & Coating Systems
                    </h5>
                  </div>
                  <div className="search-filter-box">
                    <div className="row mb-2">
                      <div className="col-md-12 col-sm-12">
                        <label className="form-label">
                          Application of Paint{" "}
                        </label>
                        <br></br>
                        <input
                          type="text"
                          value={this.state.paintAndCoating.application}
                          className="form-control"
                        ></input>
                      </div>
                      <div className="col-md-6 col-sm-6">
                        <label className="form-label">Name of Paint </label>
                        <br></br>
                        <input
                          type="text"
                          value={this.state.paintAndCoating.name}
                          className="form-control"
                        ></input>
                      </div>
                      <div className="col-md-6 col-sm-6">
                        <label className="form-label">Location </label>
                        <br></br>
                        <input
                          type="text"
                          value={this.state.paintAndCoating.location}
                          className="form-control"
                        ></input>
                      </div>
                      <div className="col-md-12 col-sm-12">
                        <label className="form-label">Remarks </label>
                        <br></br>
                        <textarea
                          className="form-control"
                          value={this.state.paintAndCoating.remarks}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Materials
                    </h5>
                  </div>
                  <div className="search-filter-box">
                    <div className="row mb-2">
                      <div className="col-md-6 col-sm-6">
                        <label className="form-label">Quantity </label>
                        <br></br>
                        <input
                          type="text"
                          className="form-control"
                          value={this.state.paintAndCoating.quantity}
                        ></input>
                      </div>
                      <div className="col-md-6 col-sm-6">
                        <label className="form-label">Unit </label>
                        <br></br>
                        <input
                          type="text"
                          className="form-control"
                          value={this.state.paintAndCoating.unit}
                        ></input>
                      </div>
                      <div className="col-md-6 col-sm-6">
                        <label className="form-label">PCHM / CHM </label>
                        <br></br>
                        <input
                          type="text"
                          className="form-control"
                          value={this.state.paintAndCoating.pchmchm}
                        ></input>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12 search-filter-box mt-2">
                    <div
                      className=" search-btn-col"
                      style={{ textAlign: "end" }}
                    >
                      {this.state.option === "Add" ? (
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.addHazardousMat()}
                        >
                          {" "}
                          Add{" "}
                        </button>
                      ) : null}
                      {this.state.option === "Edit" ? (
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.UpdateHazardousMat()}
                        >
                          {" "}
                          Update{" "}
                        </button>
                      ) : null}
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                      >
                        {" "}
                        Cancel{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  handlePaintCoatingPageChange(event) {
    this.setState({
      activePagePaintCoating: event.first,
    });
  }

  handleEquipmentPageChange(event) {
    this.setState({
      activePageEquipment: event.first,
    });
  }

  handleStructurePageChange(event) {
    this.setState({
      activePageStructure: event.first,
    });
  }

  handleStoresPageChange(event) {
    this.setState({
      activePageStore: event.first,
    });
  }

  renderPaintCoating = () => {
    const { ShowSidePan } = this.props;
    const { paintAndCoating, activePagePaintCoating } = this.state;

    const indexOfLastThing = activePagePaintCoating + 1 * this.state.rows;
    const indexOfFirstThing = indexOfLastThing - this.state.rows;

    var paintCoatingData = paintAndCoating;
    // if (paintAndCoating && paintAndCoating.length) {
    //     paintCoatingData = paintAndCoating.slice(
    //         indexOfFirstThing,
    //         indexOfLastThing
    //     );
    // }

    return (
      <>
        {paintCoatingData && paintCoatingData.length ? (
          paintCoatingData.map((item, index) => {
            return (
              <div
                className="card MM-card-content mb-0 mt-2"
                style={{
                  backgroundColor: "#fff",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div className="p-3">
                  <div className="resource-list-auth-date">
                    <div
                      className={`row  ${
                        item.isDeleted == true ? "text-strike" : ""
                      }`}
                    >
                      <div className={"col-sm-9 col-md-10 col-9 col-m-auto"}>
                        <div className="row">
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Name : </strong>
                              <span className="italicFont">{item.name}</span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Application : </strong>
                              <span className="italicFont ">
                                {item.application}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Location : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.location}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Materials : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.material}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-12 mb-1"
                            }
                          >
                            <span>
                              <strong>Remarks : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.remarks}
                              </span>
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 mb-1">
                            <span
                              className="resource-list-title"
                              style={{ fontSize: "17px" }}
                            >
                              Approximate Quantity
                            </span>
                          </div>
                          <div
                            className={ShowSidePan ? "col-sm-4" : "col-sm-3"}
                          >
                            <span>
                              <strong>Quantity : </strong>
                              <span className="italicFont ">
                                {item.quantity}
                              </span>
                            </span>
                          </div>
                          <div
                            className={ShowSidePan ? "col-sm-4" : "col-sm-3"}
                          >
                            <span>
                              <strong>Unit : </strong>
                              <span className="italicFont "> {item.unit}</span>
                            </span>
                          </div>
                          <div
                            className={ShowSidePan ? "col-sm-4" : "col-sm-3"}
                          >
                            <span>
                              <strong>PCHM / CHM : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.pchmchm}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* <div className={"col-sm-3 col-md-2 col-3 col-m-auto"}>
                        {item.isDeleted === false ? (
                          <div className="text-center">
                            <i
                              className="fa fa-edit fa-2x fa-lg click p-2"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A" }}
                              onClick={() =>
                                this.ShowSidePanel(
                                  "Edit",
                                  "paint and coating",
                                  item
                                )
                              }
                            ></i>
                            <i
                              className="fa fa-strikethrough fa-2x click p-2"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A" }}
                              onClick={() => this.deletePaintCoating(item)}
                            ></i>
                            <i
                              className="fa fa-trash fa-2x click p-2"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A" }}
                              onClick={() => this.deletePaint(item)}
                            ></i>
                          </div>
                        ) : null}
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !-- No items to Display --!
              </h6>
            </div>
          </div>
        )}

        {/* {paintCoatingData && paintCoatingData.length ? (
                    <Paginator
                        first={this.state.activePagePaintCoating}
                        rows={this.state.rows}
                        totalRecords={this.state.paintAndCoating ? this.state.paintAndCoating.length : 0}
                        onPageChange={(e) => this.handlePaintCoatingPageChange(e)}>
                    </Paginator>

                ) : (
                        <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    !-- No items to Display --!
                        </h6>
                            </div>
                        </div>
                    )} */}
      </>
    );
    // }) : null
  };

  renderEquipmentMachinery = () => {
    const { ShowSidePan } = this.props;
    const { equipmentAndMachinery, activePageEquipment } = this.state;

    const indexOfLastEquipmentThing = activePageEquipment + 1 * this.state.rows;
    const indexOfFirstEquipmentThing =
      indexOfLastEquipmentThing - this.state.rows;

    var equipmentAndMachineryData = equipmentAndMachinery;

    // if (equipmentAndMachinery && equipmentAndMachinery.length) {
    //     equipmentAndMachineryData = equipmentAndMachinery.slice(
    //         indexOfFirstEquipmentThing,
    //         indexOfLastEquipmentThing
    //     );
    // }
    return (
      <>
        {equipmentAndMachineryData && equipmentAndMachineryData.length ? (
          equipmentAndMachineryData.map((item, index) => {
            return (
              <div
                className="card MM-card-content mb-0 mt-2"
                style={{
                  backgroundColor: "#fff",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div className="p-3">
                  <div className="resource-list-auth-date">
                    <div
                      className={`row  ${
                        item.isDeleted == true ? "text-strike" : ""
                      }`}
                    >
                      <div className={"col-sm-9 col-md-10 col-9 col-m-auto"}>
                        <div className="row">
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Name : </strong>
                              <span className="italicFont ">{item.name}</span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Location : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.location}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Materials : </strong>
                              <span className="italicFont ">
                                {item.material}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Parts : </strong>
                              <span className="italicFont ">{item.parts}</span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-12 mb-1"
                            }
                          >
                            <span>
                              <strong>Remarks : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.remarks}
                              </span>
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 mb-1">
                            <span
                              className="resource-list-title"
                              style={{ fontSize: "17px" }}
                            >
                              Approximate Quantity
                            </span>
                          </div>
                          <div
                            className={ShowSidePan ? "col-sm-4" : "col-sm-3"}
                          >
                            <span>
                              <strong>Quantity : </strong>
                              <span className="italicFont ">
                                {item.quantity}
                              </span>
                            </span>
                          </div>
                          <div
                            className={ShowSidePan ? "col-sm-4" : "col-sm-3"}
                          >
                            <span>
                              <strong>Unit : </strong>
                              <span className="italicFont "> {item.unit}</span>
                            </span>
                          </div>
                          <div
                            className={ShowSidePan ? "col-sm-4" : "col-sm-3"}
                          >
                            <span>
                              <strong>PCHM / CHM : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.pchmchm}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* <div className={"col-sm-3 col-md-2 col-3 col-m-auto"}>
                        {item.isDeleted === false ? (
                          <div className="text-center">
                            <i
                              className="fa fa-edit fa-2x fa-lg click p-2"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A" }}
                              onClick={() =>
                                this.ShowSidePanel(
                                  "Edit",
                                  "equipment and machinery",
                                  item
                                )
                              }
                            ></i>
                            <i
                              className="fa fa-strikethrough fa-2x click p-2"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A" }}
                              onClick={() =>
                                this.deleteEquipmentMachinery(item)
                              }
                            ></i>
                            <i
                              className="fa fa-trash fa-2x click p-2"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A" }}
                              onClick={() =>
                                this.deleteEquipmentAndMachinery(item)
                              }
                            ></i>
                          </div>
                        ) : null}
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !-- No items to Display --!
              </h6>
            </div>
          </div>
        )}

        {/* {equipmentAndMachineryData && equipmentAndMachineryData.length ? (
                    <Paginator
                        first={this.state.activePageEquipment}
                        rows={this.state.rows}
                        totalRecords={this.state.equipmentAndMachinery ? this.state.equipmentAndMachinery.length : 0}
                        onPageChange={(e) => this.handleEquipmentPageChange(e)}>
                    </Paginator>

                ) : (
                        <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    !-- No items to Display --!
                        </h6>
                            </div>
                        </div>
                    )} */}
      </>
    );
    // }) : null
  };

  renderStructureHull = () => {
    const { ShowSidePan } = this.props;
    const { structureAndHull, activePageStructure } = this.state;
    const indexOfLastStructureThing = activePageStructure + 1 * this.state.rows;
    const indexOfFirstStructureThing =
      indexOfLastStructureThing - this.state.rows;

    var structureAndHullData = structureAndHull;
    // if (structureAndHull && structureAndHull.length) {
    //     structureAndHullData = structureAndHull.slice(
    //         indexOfFirstStructureThing,
    //         indexOfLastStructureThing
    //     );
    // }
    return (
      <>
        {structureAndHullData && structureAndHullData.length ? (
          structureAndHullData.map((item, index) => {
            return (
              <div
                className="card MM-card-content mb-0 mt-2"
                style={{
                  backgroundColor: "#fff",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div className="p-3">
                  <div className="resource-list-auth-date">
                    <div
                      className={`row  ${
                        item.isDeleted == true ? "text-strike" : ""
                      }`}
                    >
                      <div className={"col-sm-9 col-md-10 col-9 col-m-auto"}>
                        <div className="row">
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Name : </strong>
                              <span className="italicFont ">{item.name}</span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Location : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.location}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Materials : </strong>
                              <span className="italicFont ">
                                {item.material}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Parts : </strong>
                              <span className="italicFont ">{item.parts}</span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-12 mb-1"
                            }
                          >
                            <span>
                              <strong>Remarks : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.remarks}
                              </span>
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 mb-1">
                            <span
                              className="resource-list-title"
                              style={{ fontSize: "17px" }}
                            >
                              Approximate Quantity
                            </span>
                          </div>
                          <div
                            className={ShowSidePan ? "col-sm-4" : "col-sm-3"}
                          >
                            <span>
                              <strong>Quantity : </strong>
                              <span className="italicFont ">
                                {item.quantity}
                              </span>
                            </span>
                          </div>
                          <div
                            className={ShowSidePan ? "col-sm-4" : "col-sm-3"}
                          >
                            <span>
                              <strong>Unit : </strong>
                              <span className="italicFont "> {item.unit}</span>
                            </span>
                          </div>
                          <div
                            className={ShowSidePan ? "col-sm-4" : "col-sm-3"}
                          >
                            <span>
                              <strong>PCHM / CHM : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.pchmchm}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* <div className={"col-sm-3 col-md-2 col-3 col-m-auto"}>
                        {item.isDeleted === false ? (
                          <div className="text-center">
                            <i
                              className="fa fa-edit fa-2x fa-lg click p-2"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A" }}
                              onClick={() =>
                                this.ShowSidePanel(
                                  "Edit",
                                  "structure and hull",
                                  item
                                )
                              }
                            ></i>
                            <i
                              className="fa fa-strikethrough fa-2x click p-2"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A" }}
                              onClick={() => this.deleteStructureHull(item)}
                            ></i>
                            <i
                              className="fa fa-trash fa-2x click p-2"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A" }}
                              onClick={() => this.deleteStructureAndHull(item)}
                            ></i>
                          </div>
                        ) : null}
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !-- No items to Display --!
              </h6>
            </div>
          </div>
        )}
        {/* {structureAndHullData && structureAndHullData.length ? (
                    <Paginator
                        first={this.state.activePageStructure}
                        rows={this.state.rows}
                        totalRecords={this.state.structureAndHull ? this.state.structureAndHull.length : 0}
                        onPageChange={(e) => this.handleStructurePageChange(e)}>
                    </Paginator>
                ) : (
                        <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    !-- No items to Display --!
                        </h6>
                            </div>
                        </div>
                    )
                } */}
      </>
    );
    // }) : null
  };

  renderStores = () => {
    const { ShowSidePan } = this.props;
    const { store, activePageStore } = this.state;

    const indexOfLastStoreThing = activePageStore + 1 * this.state.rows;
    const indexOfFirstStoreThing = indexOfLastStoreThing - this.state.rows;

    var storeData = store;
    // if (store && store.length) {
    //     storeData = store.slice(
    //         indexOfFirstStoreThing,
    //         indexOfLastStoreThing
    //     );
    // }
    return (
      <>
        {storeData && storeData.length ? (
          storeData.map((item, index) => {
            return (
              <div
                className="card MM-card-content mb-0 mt-2"
                style={{
                  backgroundColor: "#fff",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div className="p-3">
                  <div className="resource-list-auth-date">
                    <div
                      className={`row  ${
                        item.isDeleted == true ? "text-strike" : ""
                      }`}
                    >
                      <div className={"col-sm-9 col-md-10 col-9 col-m-auto"}>
                        <div className="row">
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Name : </strong>
                              <span className="italicFont ">{item.name}</span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Location : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.location}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Materials : </strong>
                              <span className="italicFont ">
                                {item.material}
                              </span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-3 mb-1"
                            }
                          >
                            <span>
                              <strong>Parts : </strong>
                              <span className="italicFont ">{item.parts}</span>
                            </span>
                          </div>
                          <div
                            className={
                              ShowSidePan ? "col-sm-6 mb-1" : "col-sm-12 mb-1"
                            }
                          >
                            <span>
                              <strong>Remarks : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.remarks}
                              </span>
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 mb-1">
                            <span
                              className="resource-list-title"
                              style={{ fontSize: "17px" }}
                            >
                              Approximate Quantity
                            </span>
                          </div>
                          <div
                            className={ShowSidePan ? "col-sm-4" : "col-sm-3"}
                          >
                            <span>
                              <strong>Quantity : </strong>
                              <span className="italicFont ">
                                {item.quantity}
                              </span>
                            </span>
                          </div>
                          <div
                            className={ShowSidePan ? "col-sm-4" : "col-sm-3"}
                          >
                            <span>
                              <strong>Unit : </strong>
                              <span className="italicFont "> {item.unit}</span>
                            </span>
                          </div>
                          <div
                            className={ShowSidePan ? "col-sm-4" : "col-sm-3"}
                          >
                            <span>
                              <strong>PCHM / CHM : </strong>
                              <span className="italicFont ">
                                {" "}
                                {item.pchmchm}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* <div className={"col-sm-3 col-md-2 col-3 col-m-auto"}>
                        {item.isDeleted === false ? (
                          <div className="text-center">
                            <i
                              className="fa fa-edit fa-2x fa-lg click p-2"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A" }}
                              onClick={() =>
                                this.ShowSidePanel("Edit", "stores", item)
                              }
                            ></i>
                            <i
                              className="fa fa-strikethrough fa-2x click p-2"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A" }}
                              onClick={() => this.deleteStores(item)}
                            ></i>
                            <i
                              className="fa fa-trash fa-2x click p-2"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A" }}
                              onClick={() => this.deleteStore(item)}
                            ></i>
                          </div>
                        ) : null}
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !-- No items to Display --!
              </h6>
            </div>
          </div>
        )}
        {/* {storeData && storeData.length ? (
                    <Paginator
                        first={this.state.activePageStore}
                        rows={this.state.rows}
                        totalRecords={this.state.store ? this.state.store.length : 0}
                        onPageChange={(e) => this.handleStoresPageChange(e)}>
                    </Paginator>
                ) : (
                        <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    !-- No items to Display --!
                        </h6>
                            </div>
                        </div>
                    )} */}
      </>
    );
    // }) : null
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    ShowSidePan: state.SidePanReducer.sidePan || false,
    IHMSearchResults: state.MMPLDashboardReducer.MMPLIHMShipSearchResult,
    attachmentDetail: state.ShipViewReducer.attachmentDetail,
    inventoryDetail: state.ShipViewReducer.inventoryDetail,
    HazardessMaterials: state.MMPLDashboardReducer.HazardessMaterials || [],
    AddPaintCoating: state.MMPLDashboardReducer.AddPaintCoating || [],
    paintCoating: state.MMPLDashboardReducer.PaintCoating || [],
    equipmentMachinery: state.MMPLDashboardReducer.EquipmentMachinery || [],
    structureAndHull: state.MMPLDashboardReducer.StructureAndHull || [],
    store: state.MMPLDashboardReducer.Store || [],
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ViewIHMPart1Revision)
);
